import { apiGet, apiPost, apiPut, apiDelete } from "./client.js";

const BASE = "/api/v1/library";

export const listTemplates = () => apiGet(BASE).then((d) => d.templates || []);
export const getTemplate = (slug) => apiGet(`${BASE}/${slug}`);
export const createTemplate = (data) => apiPost(BASE, data);
export const updateTemplate = (slug, data) => apiPut(`${BASE}/${slug}`, data);
export const deleteTemplate = (slug) => apiDelete(`${BASE}/${slug}`);
export const seedSubTenant = (slug, subTenantId) => apiPost(`${BASE}/${slug}/seed/${subTenantId}`, {});
